import { getTraceData } from "@sentry/react";
import { createAuthClient } from "better-auth/react";
import { oneTimeTokenClient, organizationClient, usernameClient } from "better-auth/client/plugins";
import { config } from "../config";
import { getBearerToken } from "./token-store";

// better-auth uses its own fetch wrapper, which Sentry's automatic fetch
// instrumentation does not patch. Attach trace headers manually so auth
// calls join the dashboard's pageload trace on the API side.
const tracingFetch: typeof fetch = async (input, init) => {
  const headers = new Headers(init?.headers);
  const traceData = getTraceData();
  const sentryTrace = traceData["sentry-trace"];
  if (sentryTrace) {
    headers.set("sentry-trace", sentryTrace);
  }
  if (traceData.baggage) {
    headers.set("baggage", traceData.baggage);
  }
  return fetch(input, { ...init, headers });
};

export const auth = createAuthClient({
  baseURL: `${config.apiUrl}/api/auth`,
  plugins: [usernameClient(), oneTimeTokenClient(), organizationClient()],
  // Disable better-auth's automatic `window.location.href` redirect on
  // email sign-in (`{ redirect: true, url }` responses). We store the bearer
  // token from the response body first and navigate with the router, so a
  // full-page reload can never drop the token before it is persisted.
  disableDefaultFetchPlugins: true,
  fetchOptions: {
    credentials: "include",
    customFetchImpl: tracingFetch,
    auth: {
      type: "Bearer",
      token: () => getBearerToken() ?? undefined,
    },
  },
});
